import { styled } from '@mui/material';

export const Header = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
}));
